module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/img-6-142286b088212695a339e8d81f8741b9.png";